module.exports = __webpack_public_path__ + "static/cpp-67f887d989c0a00107a1808a93f52014.png";